import styles from "../../styles/FooterComponent/footer.module.css";
import "../../styles/Header/Header.css";

const socialLinks = [
  // { src: "/icon-facebook.svg", href: "", alt: "facebook_logo" },
  { src: "/icon-instagram.svg", href: "https://www.instagram.com/personalgrowthhacker/", alt: "instagram_logo" },
  { src: "/icon-mail.svg", href: "https://www.linkedin.com/company/lovencoders/", alt: "linkedin_logo" },
  { src: "/icon-youtube.svg", href: "https://www.youtube.com/channel/UCDkp-KqZH7dPQGbwRYpklhA", alt: "youtube_logo" },
];
const Footer = ({ links }) => {
  // Filter only the required links
  const filteredLinks = links.filter((link) =>
    ["/about-us", "/contact-us", "/privacy-policy"].includes(link.url)
  );
  return (
    <div className={styles.footerMainContainer}>
      <div className={styles.footerLogoAndTermsContainer}>
        <div className="logo">
        <img src="./lovencoders.svg" alt="logo" className="logoImg" />
          <h1>
            <span style={{ color: "#ff0400" }}>LOVE</span>
            <span>NCODERS</span>
          </h1>
        </div>
        <div className={styles.footerContainer}>
          {links.map((link, index) => (
            link.isFooter && <a key={index} href={link.url}>
              {link.label}
            </a>
          ))}
        </div>
      </div>
      <hr className={styles.footerHr} />
      <div className={styles.footerSocialLogoAndReservedContainer}>
        <div className={styles.footerSocialContainer}>
          {socialLinks.map((link,index)=>(
            <a href={link.href} target="_blank" key={index} rel="noreferrer">
              <img src={link.src} alt={link.alt} />
            </a>
          ))}
          {/* <a href="/facebook" target="_blank">
            <img src="/icon-facebook.svg" alt="facebook_logo" />
          </a>
          <a href="/facebook" target="_blank">
            <img src="/icon-instagram.svg" alt="instagram_logo" />
          </a>
          <a href="/facebook" target="_blank">
            <img src="/icon-mail.svg" alt="linkedin_logo" />
          </a>
          <a href="/facebook" target="_blank">
            <img src="/icon-youtube.svg" alt="youtube_logo" />
          </a> */}
        </div>
        <div className={styles.footerRightReserved}>
          ©2025 LovenCoders. All rights reserved
        </div>
      </div>
    </div>
  );
};

export default Footer;
